import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError, } from 'rxjs/operators';

import {
    FETCH_APP_LIST,
    FETCH_APP_LIST_ERROR,
    SET_APP_LIST
} from '../../constants';



const fetchAppList = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_APP_LIST),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.poiServer}/apps`,
        headers: {
          Authorization: `Bearer ${state$.value.auth.token}`,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {
          return {
            type: SET_APP_LIST,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_APP_LIST_ERROR,
            error,
          })
        )
      )
    )
  );

export default fetchAppList;
